import _ from "lodash";
import {
  CREATE_PERSONALIZATION_LEAD_REQUEST,
  CREATE_PERSONALIZED_ALIAS_REQUEST,
  CREATING_PERSONALIZATION_LEAD_FAILED,
  CREATING_PERSONALIZATION_LEAD_SUCCEEDED,
  CREATING_PERSONALIZED_ALIAS_FAILED,
  CREATING_PERSONALIZED_ALIAS_SUCCEDED,
  DELETE_PAGE_ALIAS_REQUEST,
  DELETE_PERSONALIZATION_REQUEST,
  DELETING_PAGE_ALIAS_FAILED,
  DELETING_PAGE_ALIAS_SUCCEEDED,
  DELETING_PERSONALIZATION_FAILED,
  DELETING_PERSONALIZATION_SUCCEEDED,
  FETCHING_PERSONALIZATION_CONTACTS,
  FETCHING_PERSONALIZATION_CONTACTS_FAILED,
  FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED,
  FETCHING_PERSONALIZATION_LEADS_FAILED,
  FETCHING_PERSONALIZATION_LEADS_REQUEST,
  FETCHING_PERSONALIZATION_LEADS_SUCCEDED,
  FETCHING_PERSONALIZATION_LINKS_FAILED,
  FETCHING_PERSONALIZATION_LINKS_REQUEST,
  FETCHING_PERSONALIZATION_LINKS_SUCCEDED,
  INVALIDATE_PERSONALIZATION,
  INVALIDATE_PERSONALIZATION_LEADS,
  UPDATE_PERSONALIZATION_ALIAS_REQUEST,
  UPDATE_PERSONALIZATION_REQUEST,
  UPDATING_PAGE_ALIAS_FAILED,
  UPDATING_PERSONALIZATION_ALIAS_FAILED,
  UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED,
  UPDATING_PERSONALIZATION_FAILED,
  UPDATING_PERSONALIZATION_SUCCEEDED,
  UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST,
  UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED,
  UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED,
} from "constants/actionTypes";

const initialState = {
  leads: {
    loading: false,
    fetched: false,
    error: null,
    invalidated: false,
    creating: false,
    update: {
      updating: false
    },
    deleting: false,
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
    },
  },
  links: {
    loading: false,
    error: null,
    invalidated: false,
    creating: false,
    update: {
      updating: false
    },
    deleting: false,
    items:{},
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
    },
  },
  contacts: {
    loading: false,
    fetched: false,
    error: null,
    invalidated: false,
    items: [],
    pagination: {
      current: 0,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
    },
  }
};

export function personalizationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_PERSONALIZATION_LEADS_REQUEST: {
      return {
        ...state,
        leads: {
          ...state.leads,
          loading: true,
          fetched: false,
        },
      };
    }

    case FETCHING_PERSONALIZATION_LEADS_SUCCEDED: {
      const { response } = action.payload;
      let items = [];

      if (response.currentPage !== 0) {
        items = [...state.leads.items, ...response.records];
      } else {
        items = response.records;
      }
      
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        leads: {
          ...state.leads,
          loading: false,
          fetched: true,
          items: items,
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
          },
        },
      };
    }

    case FETCHING_PERSONALIZATION_LEADS_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        leads: {
          ...state.leads,
          loading: false,
          fetched: false,
          error: error,
        },
      };
    }

    case DELETE_PERSONALIZATION_REQUEST: {
      return {
        ...state,
        leads: {
          ...state.leads,
          deleting: true,
          deleted: false
        },
      };
    }

    case DELETING_PERSONALIZATION_SUCCEEDED: {
      const { id } = action.payload;

      const updatedLeads = state.leads.items.filter((lead) => lead.id !== id);

      return {
        ...state,
        leads: {
          ...state.leads,
          deleting: false,
          deleted: true,
          items: updatedLeads,
        },
      };
    }

    case DELETING_PERSONALIZATION_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        leads: {
          ...state.leads,
          deleting: false,
          error: error,
        },
      };
    }

    case CREATE_PERSONALIZATION_LEAD_REQUEST:
    case UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST: {
      return {
        ...state,
        leads: {
          ...state.leads,
          creating: true,
        },
      };
    }

    case CREATING_PERSONALIZATION_LEAD_SUCCEEDED:
    case UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED: {
      return {
        ...state,
        leads: {
          ...state.leads,
          creating: false,
          items: [],
        },
      };
    }

    case CREATING_PERSONALIZATION_LEAD_FAILED:
    case UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED: {
      return {
        ...state,
        leads: {
          ...state.leads,
          creating: false,
        },
      };
    }

    case UPDATE_PERSONALIZATION_REQUEST: {
      return {
        ...state,
        leads: {
          ...state.leads,
          update: {
            updating: true,
            success: false
          }
        },
      };
    }

    case UPDATING_PERSONALIZATION_SUCCEEDED: {
      const { response } = action.payload;

      const updatedLeads = state.leads.items.map((lead) => {
        if (lead.id === response.id) {
          return {
            ...lead,
            mappings: response.mappings,
          };
        }
        return lead; // keep others unchanged
      });


        return {
          ...state,
          leads: {
            ...state.leads,
            update: {
              updating: false,
              success: true
            },
            items: updatedLeads,
          },
        };
    }


    case UPDATING_PERSONALIZATION_FAILED:
      {

      const { error } = action.payload;

        return {
          ...state,
          leads: {
            ...state.leads,
            update: {
              updating: false,
              success: false,
              error: error
            }
          },
        };
      }

    case  UPDATE_PERSONALIZATION_ALIAS_REQUEST:
      {
        return {
          ...state,
          links: {
            ...state.links,
            update: {
              updating: true,
              success: false
            }
          },
        };
      }
    
    case UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED: 
      const {lead, id, response } = action.payload;

      const updatedLinks = state.links.items[lead] || [];
      const updatedLink = updatedLinks.map((link) => {
        if (link.id === id) {
          return {
            ...link,
            url: response.url,
          };
        }
        return link; // keep others unchanged
      });

      {
        return {
          ...state,
          links: {
            ...state.links,
            update: {
              updating: false,
              success: true
            },
            items: {
              ...state.links.items,
              [lead]: updatedLink,
            },
          },
        };
      }

    case UPDATING_PERSONALIZATION_ALIAS_FAILED:
      {
      const { errors } = action.payload;

        return {
          ...state,
          links: {
            ...state.links,
            update: {
              success: false,
              updating: false,
              error: errors
            },
          },
        };
      }

    case CREATE_PERSONALIZED_ALIAS_REQUEST: 
    {
      return {
        ...state,
        links: {
          ...state.links,
          creating: true,
        },
      };
    }

    case CREATING_PERSONALIZED_ALIAS_SUCCEDED:     
    {
      const {response} = action.payload;
      const existingArray = state.links.items[response.personalization] || [];
      const updatedArray = [response, ...existingArray]; 

      return {
        ...state,
        links: {
          ...state.links,
          creating: false,
          items: {
            ...state.links.items,
            [response.personalization]: updatedArray
          }
        },
      };
    }

    case CREATING_PERSONALIZED_ALIAS_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        links: {
          ...state.links,
          creating: false,
          error: error
        },
      };
    }

    case FETCHING_PERSONALIZATION_LINKS_REQUEST: {

      return {
        ...state,
        links: {
          ...state.links,
          loading: true
        },
      };
    }

    case DELETE_PAGE_ALIAS_REQUEST: {
      return {
        ...state,
        links: {
          ...state.links,
          deleting: true
        },
      };
    }

    case DELETING_PAGE_ALIAS_SUCCEEDED: {
      const {id, request } = action.payload;
      const existingArray = state.links.items[request.personalization] || [];

      return {
        ...state,
        links: {
          ...state.links,
          deleting: false,
          items:{
            ...state.links.items,
            [request.personalization]: existingArray.filter(
              (item) => item.id !== id
            ),
          }
        }
      };
    }

    case DELETING_PAGE_ALIAS_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        links: {
          ...state.links,
          deleting: false,
          error: error
        },
      };
    }

    case FETCHING_PERSONALIZATION_LINKS_SUCCEDED: {
      const { id, response } = action.payload;
      const existingLinks = _.get(state, `links.items.${id}`, []);
    
      let items = [];
      if (response.currentPage !== 0) {
        items = [...existingLinks, ...response.records];
      } else {
        items = response.records;
      }
    
      items = _.uniqBy(items, 'id');
    
      return {
        ...state,
        links: {
          ...state.links,
          loading: false,
          items: {
            ...state.links.items,
            [id]: items,
          },
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
          },
        },
      };
    }    

    case FETCHING_PERSONALIZATION_LINKS_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        links: {
          ...state.links,
          loading: false,
          error: error
        }
      };
    }

    case FETCHING_PERSONALIZATION_CONTACTS: {

      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: true,
          error: null,
        },
      };
    }
    
    case FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED: {
      const { response } = action.payload;
      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: false,
          fetched: true,
          error: null,
          items: response?.records || [],
          pagination: {
            current: response?.currentPage || 0,
            totalPages: response?.totalPages || 0,
            recordsPerPage: response?.recordsPerPage || 10,
            totalRecordsCount: response?.totalRecordsCount || 0,
          }
        },
      };
    }
    
    case FETCHING_PERSONALIZATION_CONTACTS_FAILED: {
      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: false,
          error: action.payload.error,
        },
      };
    }
    

    case INVALIDATE_PERSONALIZATION_LEADS: {
      const { type } = action.payload;


      return {
        ...state,
        [type]: {
          ...state[type],
          update: {
            updating: false,
          }
        }
      };
    }



    case INVALIDATE_PERSONALIZATION: {
      return initialState;
    }
    

    default:
      return state;
  }
}
